import { formatLocalDate } from './date';

const normalizeReservationConfigDate = (value = '') => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return formatLocalDate(value);
  }

  const normalized = String(value || '').trim();
  return /^\d{4}-\d{2}-\d{2}$/.test(normalized) ? normalized : '';
};

const normalizePaymentOverride = (input = {}, index = 0) => {
  const startDate = normalizeReservationConfigDate(input.startDate);
  const endDate = normalizeReservationConfigDate(input.endDate) || startDate;
  const fallbackId = `payment-override-${index + 1}`;

  return {
    id: String(input.id || fallbackId).trim() || fallbackId,
    label: String(input.label || '').trim() || `Tarifa especial ${index + 1}`,
    startDate,
    endDate,
    paymentAmount: Math.max(0, Number(input.paymentAmount) || 0),
    active: input.active !== false
  };
};

const normalizePaymentOverrides = (overrides = []) => {
  if (!Array.isArray(overrides)) {
    return [];
  }

  return overrides
    .map((entry, index) => normalizePaymentOverride(entry, index))
    .filter((entry) => entry.startDate && entry.endDate)
    .sort((left, right) => {
      if (left.startDate === right.startDate) {
        return left.endDate.localeCompare(right.endDate);
      }
      return left.startDate.localeCompare(right.startDate);
    });
};

const findPaymentOverrideForDate = (overrides = [], reservationDate = '') => {
  const normalizedDate = normalizeReservationConfigDate(reservationDate);
  if (!normalizedDate) {
    return null;
  }

  return normalizePaymentOverrides(overrides).find((entry) => (
    entry.active
    && entry.paymentAmount > 0
    && entry.startDate <= normalizedDate
    && normalizedDate <= entry.endDate
  )) || null;
};

const resolveEffectivePaymentSettings = (settings = {}, reservationDate = '') => {
  let paymentOverrides = [];
  let appliedPaymentOverride = null;

  try {
    paymentOverrides = normalizePaymentOverrides(settings.paymentOverrides);
    appliedPaymentOverride = findPaymentOverrideForDate(paymentOverrides, reservationDate);
  } catch (error) {
    paymentOverrides = [];
  }

  const basePaymentAmount = Math.max(0, Number(settings.paymentAmount) || 0);
  const effectivePaymentAmount = appliedPaymentOverride
    ? appliedPaymentOverride.paymentAmount
    : basePaymentAmount;

  return {
    ...settings,
    paymentAmount: effectivePaymentAmount,
    paymentOverrides,
    appliedPaymentOverride
  };
};

export {
  normalizeReservationConfigDate,
  normalizePaymentOverride,
  normalizePaymentOverrides,
  findPaymentOverrideForDate,
  resolveEffectivePaymentSettings
};
